export const Chat = {
    Title: 'Chat Room',
    SnackBarNewMessages:{
        message:'You have {0} new message(s), waiting for you in the message center'
    },
    ConformationDialog:{
        Titles:{
            noBidsLeft: 'Warning'
        },
        Messages:{
            noBidsLeft: 'All providers have cancelled their bids. You will be forwarded to View Bids screen.'
        },
        Buttons:{
            Ok:{
                label: 'Ok'
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/localization/Chat.ts